/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_AnnonceInputs */

const cs_enum_annonce = /** @type {(inputs: Enum_AnnonceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annonce`)
};

const en_enum_annonce = /** @type {(inputs: Enum_AnnonceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annonce`)
};

/**
* | output |
* | --- |
* | "Annonce" |
*
* @param {Enum_AnnonceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_annonce = /** @type {((inputs?: Enum_AnnonceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_AnnonceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_annonce(inputs)
	return cs_enum_annonce(inputs)
});